<template>
  <div>
    <v-row v-for="(part, partIndex) in offer.parts" :key="partIndex">
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.carRental')" filled readonly v-model="part.name"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.pickupDate')" filled readonly v-model="part.start_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.returnCarDate')" filled readonly v-model="part.end_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.carClass')" filled readonly v-model="part.car_class"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.pickupPlace')" filled readonly v-model="part.from"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.returnCarPlace')" filled readonly v-model="part.to"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.averagePricePerDay')" filled readonly v-model="part.price_per_day"></v-text-field>
      </v-col>
      <v-col class="pa-1" cols="12">
        <v-textarea :label="$t('travelService.travelAgentComment')" filled readonly v-model="part.comment"></v-textarea>
      </v-col>
      <v-col v-if="partIndex < offer.parts.length - 1" cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CarResponsePresentation",
  props: {
    offer: {
      required: true
    }
  }
};
</script>

<style scoped></style>
